import React from 'react';
import DateRangePicker from './DateRangePicker';
import { PeriodoRapido, PERIODOS_RAPIDOS, RangeISO } from '../lib/periodoRapido';

interface SeletorPeriodoRapidoProps {
    value: PeriodoRapido;
    customRange: RangeISO | null;
    onChange: (periodo: PeriodoRapido, customRange: RangeISO | null) => void;
}

/**
 * Hoje / Esta semana / Última semana / Este mês / Mês anterior / Período
 * personalizado — mesmo padrão de pills já usado em telas de análise do Rotas
 * (ProdutividadeDashboard, AderenciaPanel, OperacionalDashboard, CapturasPanel),
 * trocando o "Personalizado" solto por dois campos de data pelo calendário
 * de verdade que o módulo Marketing já usa (DateRangePicker). Pensado pra ser
 * reaproveitado — não é específico do SLA de Atendimento.
 */
const SeletorPeriodoRapido: React.FC<SeletorPeriodoRapidoProps> = ({ value, customRange, onChange }) => {
    return (
        <div className="flex flex-wrap items-center gap-2">
            <div className="flex items-center flex-wrap gap-1 p-1 bg-gray-100 dark:bg-gray-700/50 rounded-full border border-gray-200 dark:border-gray-700">
                {PERIODOS_RAPIDOS.map(p => (
                    <button
                        key={p.value}
                        type="button"
                        onClick={() => onChange(p.value, p.value === 'personalizado' ? customRange : null)}
                        className={`px-3 py-1 text-xs font-semibold rounded-full transition-all whitespace-nowrap ${value === p.value ? 'bg-white dark:bg-gray-600 text-primary shadow-sm' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
                    >
                        {p.label}
                    </button>
                ))}
            </div>
            {value === 'personalizado' && (
                <DateRangePicker
                    startDate={customRange?.inicio || ''}
                    endDate={customRange?.fim || ''}
                    onChange={(inicio, fim) => onChange('personalizado', inicio && fim ? { inicio, fim } : null)}
                    placeholder="Escolher datas"
                />
            )}
        </div>
    );
};

export default SeletorPeriodoRapido;
